import React, { useRef, useEffect } from "react";
import "../../web-components/switch-lgpd";

const SwitchLgpd = ({ type, error, onChange }) => {
  const switchRef = useRef();

  const handleEvent = (e) => {
    e.preventDefault();
    onChange(e.detail);
  };

  useEffect(() => {
    switchRef.current.addEventListener(
      "onChange",
      (e) => {
        handleEvent(e);
      },
      false
    );

    return () =>
      switchRef.current.removeEventListener(
        "onChange",
        (e) => {
          handleEvent(e);
        },
        false
      );
  }, []);

  return (
    <switch-lgpd ref={switchRef} default-value={type} error-message={error} />
  );
};

export default SwitchLgpd;
